export default {
	tm:'此记',
	qjt:'秋俊天',
	amap:'高德地图',
	copyright:'©@year 此记·秋俊天',
	username:'账号',
	nickname:'昵称',
	password:'密码',
	email:'邮箱',
	wechat:'微信',
	registertime:'注册时间',
	verifyCode:'验证码',
	terms:"服务条款",
	contactUs:"联系我们",
	contactUsText:"请发送邮件至",
	user:"此记用户",
	space:"",
	loading:"读取中...",
	hello:{
		morning:'「@nickname」上午好',
		afternoon:'「@nickname」下午好',
		evening:'「@nickname」晚上好',
		midnight:'「@nickname」凌晨了',
		slogan1:'此生此夜不长好，惟愿此记忆平生',
		slogan2:'此记亦悠悠',
		slogan3:'我是人间惆怅客，知君何事泪纵横',
		slogan4:'随君万里，想期始终',
		slogan5:'三步两步，便是天堂',
		slogan6:'山河虽远亦复见',
	},
	sloganNum:'6',
	footprint:{
		fp:'足迹',
		longitude:'经度',
		latitude:'纬度',
		scale:'缩放等级',
		address:'地址',
		addressEmpty:'暂无地址',
		note:'备注',
		noteInputTip:'备注字数：',
		noteEmpty:'暂无备注',
		time:'时间',
		timeFormat:'YYYY年MM月DD日 HH:mm:ss',
		icon:'图标',
		empty:'暂无足迹',
	},
	icon:{
		all:'全部',
		cluster:'足迹盒子',

		default:'此记默认',
		note:'笔记',

		family:'家庭',
		love:'伴侣',
		friend:'朋友',
		pet:'宠物',
		workf:'工作（女）',
		workm:'工作（男）',
		student:'学生',

		food:'美食',
		travel:'旅行',
		photo:'摄影',
		shopping:'购物',
		amusement:'娱乐',
		sport:'运动',

		special:'特殊',
		positive:'正能量',
		negative:'负能量',

		jnq:'将年轻',
	},
	btn:{
		close:'关闭',
		return:'返回',
		returnLast:'返回上页',
		returnIndex:'返回首页',
		top:'回到顶部',
		login:'登录',
		bind:'绑定',
		unbind:'解绑',
		logout:'注销登录',
		signup:'加入此记',
		forget:'忘记密码',
		record:'记录',
		edit:'编辑',
		delete:'删除',
		modify:'修改',  
		share:'分享',
		shareEnd:'退出',
		reset:'重置',
		sendLink:'发送验证链接',
		change:'更改',
		send:'发送',
		second:'秒',
		relocate:'重新定位',
		mapFull:'地图全屏',
		mapWindow:'地图缩小',
	},
	form:{
		usernameSub:"用于登录，6-15位/只限于英文大小写、数字",
		passwordSub:"用于登录，6-15位/只限于英文大小写、数字",
		repasswordSub:"重复输入一次",
		nicknameSub:"用于显示，1-10位/可以为中（繁简）英文、数字、-_",
		emailSub:"用于接收账户安全信息及重置密码",
		verifyCodeSub:"8位证码",
		shareTitleSub:"分享标题（可为空），1-10位/可以为中（繁简）英文、数字、-_",

		nullError:"该项不能为空",
		lengthError:"字符数应介于@min与@max之间",
		lengthOnlyError:"字符数应为@length位",
		n0Error:"只限于数字",
		Aa0Error:"只限于英文大小写、数字",
		Aa0ZhZhtUDError:"只限于中（繁简）英文、数字、-_",
		emailError:"邮箱格式不符合规范",
		sameError:"与@feild不相同，请重新输入",
		repeatError:"@feild已经被占用，请修改",
	},
	_login:{
		title:'登录',
	},
	_signup:{
		title:'加入此记',
	},
	_index:{
		title:'首页',
	},
	_forget:{
		title:'忘记密码',
	},
	_record:{
		title:'记录足迹',
		info:'足迹信息',
		selectIcon:'选择图标',
		inputNote:'填写备注（可为空）',
	},
	_review:{
		title:'回顾足迹',

		review:'回顾',
		map:'地图',

		mapsettings:'地图设置',

		mapcluster:'足迹聚合',
		mapclustertips:'足迹过多时，关闭聚合可能导致性能降低',

		mapstyle:'地图样式',
		mapdefault:'高德默认',
		maproad:'高德路网',
		mapsat:'高德卫星',
		mapsatroad:'高德卫星路网',
		mapgoogle:'谷歌默认',
		mapgooglegeo:'谷歌地理',
		mapgooglesat:'谷歌卫星',
		mapstamentoner:'Stamen黑白',
		mapstamenwatercolor:'Stamen水彩',

		detail:'详情',
		modifyIcon:'修改图标',
		modifyNote:'修改备注',
		openedBy:'在导航应用打开',

		search:'足迹搜索',
		searchPlaceHolder:'输入相关信息，空格分割关键词',
		searched:'当前搜索到@count个足迹',
		
		shareTip:'点击足迹进行选择\n选择完成后点击“足迹分享”',
		shareSelected:'已选择',
		shareSelectedRepeat:'该足迹已经被选中',
	},
	_achievement:{
		title:'我的成就',

		all:'全部',
		fp:'足迹',
		china:'中国',
		world:'世界',
		special:'特殊',
		achi:'成就',

		empty:'暂无足迹成就',

		getAchi:'获得新成就',
		getSpecial:'完成于',
		notGetSpecial:'暂未全部完成',

		mostRecord:'最常记录',
		mostActive:'最常活动于',
	},
	share:{
		footprint:'足迹分享',
		achievement:'成就分享',
		sharedBy:'分享自',
		shareS:'的',
		join:'扫描二维码关注微信公众号\n或点击',
	},
	_shareFoorprints:{
		title:'足迹分享',
	},
	_shareAchievement:{
		title:'成就分享',

		overview:'成就总览',
		overview1:'自从「@time」以来，我已记录足迹',
		overviewPrefix:'共',
		overviewUnit:'个',
	},
	_settings:{
		title:'我的设置',
		settings:'设置项',
		shared:'分享列表',
		unrecorded:'待记足迹',

		info:'账号信息',
		language:'Language',
		resetPassword:'重置密码',
		changeMail:'更改邮箱',
		unbindWechat:'解绑微信',
		unbindEmpty:'暂未绑定微信',

		submit:'提交列表',
		share:'分享列表',
		option:'操作',
		listEmpty:'列表暂无内容',
		sharedFp:'足迹',
		pageView:'浏览',
	},
	_resetPassword:{
		title:'重置密码',
		newPassword:'新密码',
	},
	_changeMail:{
		title:'更改邮箱',
		newMail:'新邮箱',
	},
	_wechatBind:{
		title:'绑定微信',
		tips:'在此登录您的此记账号即可完成绑定',
	},
	_about:{
		title:'关于与帮助',
		slogan:'现在好了，\n你已拥有一个崭新的此记。',
		wechat:'将账号绑定到此记公众平台后，可以利用微信进入',

		recordSlogan:'此时此地，在空间中创建属于自己的唯一坐标',
		recordHelp1:'首页点击如下图标，进入此功能。',
		recordHelp2:'此功能需要开启GPS的定位功能，并且同意此记使用定位功能（部分桌面端浏览器可能无法定位）。',
		recordHelp3:'如果弹出是否允许使用位置的对话框，请选择允许；否则程序将不能定位。当地图上显示足迹图标，说明定位成功。',
		recordHelp4:'在地图右下角可能会有两个按钮，功能如下：',
		recordHelp41:'微信记录不会出现',
		recordHelp5:'选择足迹图标、填写足迹备注（备注可以为空）。',
		recordHelp61:'点击页面底部',
		recordHelp62:'，保存当前足迹。',
		
		reviewSlogan:'回顾走过的路，与他人分享',
		reviewHelp1:'首页点击如下图标，进入此功能。',
		reviewHelp2:'查看足迹：点击任何一个地图上的足迹图标，进入足迹详情。',
		reviewHelp3:'修改足迹：足迹详情 → 编辑 → 修改内容 → 修改足迹。',
		reviewHelp4:'删除足迹：足迹详情 → 编辑 → 删除。',
		reviewHelp5:'搜索足迹：点击如下图标进入，输入相关信息进行搜索，可以用空格分割关键词（点击足迹图标可以添加图标分类搜索条件）。',
		reviewHelp6:'地图设置：点击如下图标进入，可以设置地图相关显示偏好。',
		reviewHelp7:'足迹分享：点击如下图标进入。',

		achiSlogan:'「为了世界和平，我要练到满级！」',
		achiHelp1:'首页点击如下图标，进入此功能。系统会自动显示您已经开启的足迹成就。',
		achiHelp2:'足迹成就：点击如下图标进入。',

		settingSlogan:'带着背包和个性，走遍世界',
		settingHelp1:'首页点击如下图标，进入此功能。',
		settingHelp2:'设置项：可以设置语言、重置密码等操作。',
		settingHelp3:'已分享：管理自己已分享的足迹、成就页面。',
		settingHelp31:'查看已分享页面',
		settingHelp4:'未提交：管理自己已提交还未记录的足迹。',
		settingHelp41:'点击记录该足迹',

		wechatHelp1:'此记不会以任何理由索要您的微信账号和密码，谨防上当受骗。',
		wechatHelp2:'绑定微信的好处',
		wechatHelp211:'定位功能',
		wechatHelp212:'定位更准确\n定位更快速',
		wechatHelp221:'安全性',
		wechatHelp222:'无须验证密码\n灵活安全',
		wechatHelp231:'弹性记录',
		wechatHelp232:'一次提交多个足迹\n逐一填写备注',
		wechatHelp3:'如何绑定',
		wechatHelp31:'首先，你必须拥有一个此记的账户，如果没有，请注册。',
		wechatHelp32:'关注此记微信公众平台：搜索微信号「thismemo」或扫描下方二维码。',
		wechatHelp33:'进入公众号，点击页面正下方「绑定微信」。',
		wechatHelp34:'在页面中，输入此记账号和密码，提示成功后，即可使用微信来登录、操作此记了。',
		wechatHelp4:'如何解绑',
		wechatHelp41:'任意方式登录此记，首页 → 我的设置 → 设置项 → 解除绑定。',

		others:'其他',
		acknowledgement:'感谢「林老北」、「哲仔」、「林大雨」、「饺子」',
	},
	_404:{
		title:'404',
		tip:'该页面已经不复存在\n大家都在寻找它',
	},
	_notice:{
		title:'提示',
		AUTH_FAILED:'链接已失效，请在微信公众号中再次发送',
		BIND_WECHAT_SUCCESS:'绑定成功！关闭此页面即可使用微信版此记功能',
		ALREADY_BIND_WECHAT:'该微信已经绑定了此记账号，无需再次绑定。如需更换此记账号，请解绑后再试',
	},
	BACKENDMSG:{
		undefined:'未知错误，请稍后再试',
		UNKNOWN_ERROR:'未知错误，请稍后再试',
		WRONG_SESSION:'登录过期，请重新登录',
		WRONG_TOKEN:'登录失效，请重新登录',
		DIFFERENT_TOKEN:'登录失效，请重新登录',
		LOGIN_SUCCESS:'登录成功',
		LOGIN_WRONG_USERNAME:'账号错误',
		LOGIN_WRONG_PASSWORD:'密码错误',
		LOGOUT_SUCCESS:'注销登录成功',
		RFP_M_Q:'确认修改足迹？',
		RFP_M_END_Q:'足迹已经更改，确认放弃修改？',
		RFP_M_FAIL:'足迹修改失败，请稍后再试',
		RFP_M_SAME:'足迹没有修改，不能提交',
		RFP_M_SUCCESS:'足迹修改成功',
		RFP_D_Q:'足迹删除不可恢复，确认删除么？',
		RFP_D_FAIL:'足迹删除失败，请稍后再试',
		RFP_D_SUCCESS:'足迹删除成功',
		RFP_SH_FAIL:'没有选择足迹，不能分享',
		RFP_SH_SUCCESS:'分享页面生成中，请等待页面跳转',
		RECFP_LOCATE_ERROR:'获取位置失败，请检查网络、GPS设置、允许获取地理位置。\n确认后请点击重新定位按钮。',
		RECFP_LOCATE_NOT_HTTPS:'获取位置失败，请联系管理员。',
		RECFP_LOCATE_PERMISSION_DENIED:'获取位置失败，请允许获取位置的权限。',
		RECFP_LOCATE_POSITION_UNAVAILABLE:'获取位置失败，当前位置信息不可用。',
		RECFP_LOCATE_TIMEOUT:'获取位置失败，获取位置信息超时。',
		RECFP_LOCATE_UNKNOWN_ERROR:'获取位置失败，未知错误。',
		RECFP_RELOCATE:'正在重新定位，请稍后再试',
		RECFP_REC_FAIL:'记录足迹失败，请稍后再试',
		RECFP_REC_SUCCESS:'记录足迹成功',
		ACHI_FAIL:'读取成就失败，请稍后再试',
		ACHI_SUCCESS:'读取成就成功',
		U_SETLANG_SUCCESS:'保存常用语言成功',
		U_SETLANG_FAIL:'保存常用语言失败，请稍后再试',
		U_UNBIND_WECHAT_Q:'确认解绑微信？',
		U_LIST_D_Q:'删除后不可恢复，确认删除？',
		SIGNUP_SEND_WRONG_EMAIL:'请输入正确的邮箱地址',
		SIGNUP_SEND_1MIN:'请在@sec秒后再次尝试发送',
		SIGNUP_SUCCESS:'注册成功',
		SEND_EMAIL_SUCCESS:'相关信息成功发送至@email\n请检查收件箱及垃圾邮件',
		SEND_EMAIL_FAIL:'发送邮件失败，请稍后再试',
		SEND_EMAIL_EMPTY:'您的账号还未绑定邮箱\n请点击页面底部联系我们，联系管理员绑定邮箱',
		FORM_WRONG:'输入信息不合符规范，请检查',
		FORM_VC_SEND_SUCCESS:'验证码成功发送至@email\n请检查收件箱及垃圾邮件',
		FORM_VC_WRONG:'验证码错误，请检查',
		FORM_VC_EXPIRED:'验证码已过期，请重新发送',
		RESET_EXPIRED:'链接已过期，请重新发送',
		RESET_UNFOUND:'链接已不存在，请重新发送',
		RESET_SUCCESS:'更改成功',
		RESET_P_SAME:'新旧密码相同，请输入不同的密码',
		RESET_MAIL_SAME:'新旧邮箱相同，请输入不同的邮箱',
		RESET_LOGIN_FORGET_UNFOUND_USERNAME:'没有找到登录账户，请重新输入',
		RESET_LOGIN_FORGET_EMAIL_UNSAME:'您输入的邮箱地址与注册时的不同，请重新输入',
		UNBIND_SUCCESS:'解除绑定成功',
		NOT_BIND_WECHAT:'暂未绑定微信',
		BIND_WECHAT_UNFOUND:'链接已失效，请在微信公众号中再次发送',
		TAKEN_BIND_WECHAT:'您的微信已经绑定了其他账号，请解绑后再试',
		ALREADY_BIND_WECHAT:'您的账号已经绑定了其他微信，请解绑后再试',
		BIND_SUCCESS:'成功绑定微信，您已可以在公众号中使用所有功能',
		REDIRECT_UNFOUND:'链接已失效',
	}
}



// WEBPACK FOOTER //
// ./src/lang/zh.js